export default __webpack_public_path__ + "static/media/icons8-whatsapp.7dc3f326.svg";